import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowUpRightSquare: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2' }],
    ['path', { d: 'M8 8h8v8' }],
    ['path', { d: 'm8 16 8-8' }],
  ],
];

export default ArrowUpRightSquare;
